import React, {useRef} from 'react';

import { TextareaContainer, Textarea, FloatingLabel, } from './styles';

function TextArea({label, value, onChange, disabled, name, error, textAreaRef, ...rest}) {
  return (
    <TextareaContainer>
      <Textarea
        disabled={disabled}
        name={name}
        value={value}
        onChange={onChange}
        error={error}
        ref={textAreaRef}
        {...rest}
      />

      <FloatingLabel
        error={error}
        className="floating-label"
      >
        {label}
      </FloatingLabel>
    </TextareaContainer>
  );
}

export default TextArea;
